"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
var legup_model_1 = require("@legup/legup-model");
var react_1 = __importDefault(require("react"));
var strings_1 = __importDefault(require("../strings"));
var LimitTextField_1 = require("./LimitTextField");
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var Address = function (props) {
    var _a = react_1.default.useState(props.address ? props.address.copy() : new legup_model_1.Address()), address = _a[0], setAddress = _a[1];
    react_1.default.useEffect(function () {
        setAddress(props.address ? props.address.copy() : new legup_model_1.Address());
    }, [props.address]);
    var onChangeStreet1 = function (e) {
        var a = address.copy();
        a.setStreetAddress1(e.target.value);
        setAddress(a);
        if (props.onChange) {
            props.onChange(a, e.target.name);
        }
    };
    var onChangeStreet2 = function (e) {
        var a = address.copy();
        a.setStreetAddress2(e.target.value);
        setAddress(a);
        if (props.onChange) {
            props.onChange(a, e.target.name);
        }
    };
    var onChangeCity = function (e) {
        var a = address.copy();
        a.setCity(e.target.value);
        setAddress(a);
        if (props.onChange) {
            props.onChange(a, e.target.name);
        }
    };
    var onChangeState = function (e) {
        var a = address.copy();
        a.setState(e.target.value);
        setAddress(a);
        if (props.onChange) {
            props.onChange(a, e.target.name);
        }
    };
    var onChangePostalCode = function (e) {
        var a = address.copy();
        a.setPostalCode(e.target.value);
        setAddress(a);
        if (props.onChange) {
            props.onChange(a, e.target.name);
        }
    };
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
        !props.cityOnly && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement(LimitTextField_1.LimitTextField, { error: props.errorStreetAddress, id: props.name + "_street_address_1", name: "street_address_1", key: props.name + "_street_address_1", variant: "outlined", size: "small", label: strings_1.default.address.address, fullWidth: true, disabled: props.readOnly, limit: 128, showCount: false, value: address.street_address_1, onChange: onChangeStreet1 }))),
        !props.cityOnly && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement(LimitTextField_1.LimitTextField, { id: props.name + "_street_address_2", name: "street_address_2", key: props.name + "_street_address_2", variant: "outlined", size: "small", label: strings_1.default.address.address2, fullWidth: true, disabled: props.readOnly, limit: 128, showCount: false, value: address.street_address_2, onChange: onChangeStreet2 }))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 6 },
            react_1.default.createElement(LimitTextField_1.LimitTextField, { error: props.errorCity, id: props.name + "_city", name: "city", key: props.name + "_city", variant: "outlined", size: "small", label: strings_1.default.address.city, fullWidth: true, disabled: props.readOnly, limit: 128, showCount: false, value: address.city, onChange: onChangeCity })),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 2 },
            react_1.default.createElement(InputLabel_1.default, { htmlFor: props.name + "_state", id: props.name + "_state_label" }, strings_1.default.address.state),
            react_1.default.createElement(Select_1.default, { style: { height: 40, width: "100%" }, error: props.errorState, id: props.name + "_state", name: "state", key: props.name + "_state", variant: "outlined", disabled: props.readOnly, value: address.state ? address.state : "", onChange: onChangeState },
                react_1.default.createElement(MenuItem_1.default, { key: "none", id: props.name + "_state_menu_none", value: "" }, "----"),
                (address.state && address.state.length && (strings_1.default.address.states.indexOf(address.state) === -1))
                    ? react_1.default.createElement(MenuItem_1.default, { key: address.state, id: props.name + "_state_menu_" + address.state, value: address.state }, address.state)
                    : null,
                strings_1.default.address.states.map(function (option) { return (react_1.default.createElement(MenuItem_1.default, { key: option, id: props.name + "_state_menu_" + option, value: option }, option)); }))),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 4 },
            react_1.default.createElement(LimitTextField_1.LimitTextField, { error: props.zipcodeValidationError, id: props.name + "_postal_code", name: "postal_code", key: props.name + "_postal_code", variant: "outlined", size: "small", label: strings_1.default.address.zipCode, fullWidth: true, value: address.postal_code, disabled: props.readOnly, limit: 16, showCount: false, onChange: onChangePostalCode }),
            react_1.default.createElement("div", { style: { color: "Red" } }, props.zipcodeValidationError
                ? strings_1.default.address.zipcodeValidationError
                : null))));
};
exports.Address = Address;
